import SwitchButton from '../switch-button-field/SwitchButton';

interface CustomInputSwitchInterface {
  readonly inputLabel?: string;
  readonly value?: boolean;
  readonly name: string;
  readonly onChangeValue: (name: string, value: boolean) => void;
  fontSize?: 'small' | 'medium' | 'large';
}

/**
 * Custom input select box component
 * @param {any} param0 - The param0
 * @param {any} param0.inputLabel - The inputLabel prop
 * @param {any} param0.value - The value prop
 * @param {any} param0.name - The name prop
 * @param {any} param0.onChangeValue - The onChangeValue prop
 * @param {any} param0.fontSize - The fontSize prop
 * @returns {any} The result
 */
function CustomInputSwitch({
  inputLabel,
  value,
  name,
  onChangeValue,
  fontSize,
}: CustomInputSwitchInterface) {
  return (
    <div className={`custom-input-switch-button-wrap ${fontSize}`}>
      <div className="switch-size">
        <SwitchButton
          checked={value}
          change={() => onChangeValue(name, !value)}
          fontSize={fontSize}
        />
      </div>
      {inputLabel && (
        <p className="input-label" role="presentation" onClick={() => onChangeValue(name, !value)}>
          {inputLabel}
        </p>
      )}
    </div>
  );
}

CustomInputSwitch.defaultProps = {
  inputLabel: '',
  value: false,
  fontSize: 'large',
};

export default CustomInputSwitch;
